import styled from "styled-components";

// Higher than the former 10rem: the mockup options are taller, and 5 candidates still fit without scrolling.
const MODAL_MARGIN_TOP = "5rem";

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 15px 20px 15px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    border-bottom: 1px solid #e5e5e5;
`;

export const ModalBody = styled.div`
    padding: 20px 15px 20px 15px;
`;

export const ModalTitle = styled.h2`
    margin: 0;
    font-size: inherit;
    font-weight: inherit;
`;

// 28px square, above the 24px minimum target size (WCAG 2.5.8). The negative
// margin keeps the header height unchanged.
export const CloseButton = styled.button`
    display: flex;
    padding: 4px;
    margin: -4px;
    border: 0;
    background: none;
    cursor: pointer;
`;

export const customStylesModal = {
    overlay: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(142, 142, 142, 0.6)",
        overflowY: "scroll" as const,
        zIndex: "999",
    },
    content: {
        position: "initial" as const,
        margin: `${MODAL_MARGIN_TOP} auto auto`,
        padding: 0,
        border: "1px solid rgba(0,0,0,0.2)",
        maxHeight: "fit-content",
        maxWidth: "680px",
        borderRadius: "4px",
        boxShadow: "0 5px 15px rgb(0 0 0 / 50%)",
    },
};
